import request from "@/api";
import { BaseService } from "@/api/services/baseService";
import { Article } from "@supplier/entity";
import { ArticleForm } from "@/entity/manageCenter/article";
import { confirmable } from "@/utils/decorator/confirmable";
import { AxiosRequestConfig } from "axios";

export class ArticleService extends BaseService<Article, Article, unknown, ArticleForm> {
    /**
     * 根据类型查询
     * @param params
     */
    public async find(params: { type: number; app: number } = { type: 1, app: 1 }): Promise<Article> {
        const { data } = await this.service.get(`${this.path}/type`, {
            params: {
                type: params.type,
                app: params.app || 1
            }
        });
        return data;
    }

    // 新增
    @confirmable("是否提交")
    public async createOfEnterpriseCustom(form: ArticleForm) {
        const { data } = await this.service.post(`${this.path}/createOfEnterpriseCustom`, form, {
            loading: true
        } as AxiosRequestConfig);
        return data;
    }

    // 修改
    @confirmable("是否提交")
    public async updateOfEnterPriseCustom(id: number | string, form: ArticleForm) {
        const { data } = await this.service.put(`${this.path}/updateOfEnterPriseCustom/${id}`, form, {
            loading: true
        } as AxiosRequestConfig);
        return data;
    }
}

export const articleService = new ArticleService("/article", request.service);
